import React from 'react';
import './CasesBlock.less';
import Matter from "../../entities/matter";
import Icons from "../../ui/IconButton/Icons";
import Lead from "../../entities/lead";
import LeadStage from '../../CRM/Sales/LeadStage';
import {formatFMLFromId, replaceNames} from "../../Contacts/ContactFormat";
import RoutedIconButton from "../../ui/Buttons/RoutedIconButton";

function CasesBlock(props: CasesBlockProps) {
    return (
        <div className='cases-block'>
            {props.leads.map(lead => {
                const leadName = window.__demo_mode__ ? replaceNames(lead.clients, lead.name) : lead.name;
                const clientNames = lead.clients.map(cid => formatFMLFromId(cid)).join(' and ');
                const names = window.__demo_mode__ ? replaceNames(lead.clients, clientNames) : clientNames;

                const label = <div className='u-items u-wrap'>
                    <div><b>{leadName}</b></div>
                    <div className='u-client'>{names}</div>
                    <div style={{fontSize: '.9em'}}><LeadStage lead={lead} useDate={true}/></div>
                </div>;

                return <RoutedIconButton key={lead.id}
                                         type={Icons.LEAD}
                                         label={label}
                                         route={`/sales/${lead.id}?returnTo=marketing`}
                />;
            })}

            {props.matters.map(matter => {
                const matterName = window.__demo_mode__ ? replaceNames(props.leads.find(l => l.id === matter.leadId)?.clients || [], matter.name) : matter.name;
                const clientNames = matter.clients.map(cid => formatFMLFromId(cid)).join(' and ');
                const names = window.__demo_mode__ ? replaceNames(matter.clients, clientNames) : clientNames;

                const label = <div className='u-items u-wrap'>
                    <div><span style={{fontSize: '.8em'}} className='u-code'>{matter.code}</span> <b>{matterName}</b>
                    </div>
                    <div className='u-client'>{names}</div>
                </div>;

                return <RoutedIconButton key={matter.id}
                                         type={Icons.CASE}
                                         label={label}
                                         route={`/cases/${matter.id}?returnTo=marketing`}
                />;
            })}
        </div>
    );
}

export type CasesBlockProps = {
    matters: Matter[],
    leads: Lead[],
};

export default CasesBlock;
